<template>
    <div class="jobs" v-if="$root.dataReady">
        <div class="container">
            <div class="jobs__content">
                <div
                    class="jobs__image"
                    :style="{ 'background-image': 'url( ' + post.better_featured_image.source_url + ' )' }"
                >
                    <span class="jobs__title" v-html="post.acf.job_title"></span>
                </div>
                <p class="jobs__position" v-html="post.acf.position"></p>
                <p class="jobs__city" v-html="post.acf.city"></p>
                <p class="jobs__description" v-html="post.acf.content"></p>
                <div class="jobs__grey-box" v-html="post.acf.grey_box"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "jobs",
    data() {
        return {
            post: null
        };
    },
    created: function() {
        this.$root.dataReady = false;
        this.$root.headeriswhite = false;
    },
    mounted: function() {
        this.fetchData();
    },
    methods: {
        fetchData: function() {
            var self = this;
            $.get(
                self.$root.apiUrl + "wp-json/wp/v2/jobs?slug=" +
                    self.$route.params.name,
                function(response) {
                    if (!response[0]) {
                        self.$router.push({ name: "page-not-found" });
                    } else {
                        // console.log(response[0]);
                        self.post = response[0];
                        self.setTitle(response[0].title.rendered);
                        self.$root.dataReady = true;
                    }
                }
            )
                .done(function() {})
                .fail(function() {});
        },
        setTitle: function(title) {
            title = title.normalize('NFD').replace("&#038;", "&");
            document.title = title + " - Weber Shandwick";
        }
    }
};
</script>



// WEBPACK FOOTER //
// Jobs.vue?143d7e2c